import { render, staticRenderFns } from "./notification-list-page.vue?vue&type=template&id=65251cdf&scoped=true&"
import script from "./notification-list-page.vue?vue&type=script&lang=js&"
export * from "./notification-list-page.vue?vue&type=script&lang=js&"
import style0 from "./notification-list-page.vue?vue&type=style&index=0&id=65251cdf&lang=scss&scoped=true&"
import style1 from "./notification-list-page.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65251cdf",
  null
  
)

export default component.exports
import {QTabs,QTab,QBadge,QTabPanels,QTabPanel} from 'quasar'
component.options.components = Object.assign(Object.create(component.options.components || null), component.options.components || {}, {QTabs,QTab,QBadge,QTabPanels,QTabPanel})
